module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/mstile-150x150-f6cb7b254e7fbc0ef34f506a9f5874cd.png";